import React from 'react';
import '../../App.css';
export class Footerappprivate extends React.Component {
    render() {
        return (
            <div className='sshfooterapp'>
            

            
            </div>
        );
    }
}